export default function(
    userFeedbackForm: HTMLFormElement,
    starIcons: NodeListOf<HTMLElement>,
): void {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    const feedbackInput = userFeedbackForm.querySelector('#userFeedbackInput') as HTMLDivElement|null;
    const userRating = userFeedbackForm.querySelector('#userRating') as HTMLInputElement|null;
    const feedbackBody = userFeedbackForm.querySelector('#userFeedback') as HTMLTextAreaElement|null;
    const uniqueId = userFeedbackForm.querySelector('#feedbackId')?.textContent as string;

    if (
        feedbackBody === null
        || userRating === null
        || csrfToken === null
        || csrfToken === undefined
        || uniqueId === ''
    ) {
        return;
    }

    starIcons.forEach((icon) => {
        icon.addEventListener('mouseleave', () => {
            const setRating: number = parseInt(userRating.value);

            setRatingDescription(setRating);
            updateIcons(setRating, starIcons);
        });

        icon.addEventListener('mouseover', () => {
            if (icon.dataset.feedbackRating === undefined) {
                return;
            }

            const chosenRating: number = parseInt(icon.dataset.feedbackRating);

            setRatingDescription(chosenRating);
            updateIcons(chosenRating, starIcons, true);
        });

        icon.addEventListener('focus', () => {
            if (icon.dataset.feedbackRating === undefined) {
                return;
            }

            const chosenRating: number = parseInt(icon.dataset.feedbackRating);

            setRatingDescription(chosenRating);
            updateIcons(chosenRating, starIcons, true);
        });

        icon.addEventListener('click', () => {
            if (icon.dataset.feedbackRating === undefined) {
                return;
            }

            const chosenRating: number = parseInt(icon.dataset.feedbackRating);

            setRatingDescription(chosenRating);
            updateIcons(chosenRating, starIcons);

            userRating.value = chosenRating.toString();

            if (feedbackInput !== null) {
                if (chosenRating === 5) {
                    feedbackInput.classList.add('d-none');
                } else {
                    feedbackInput.classList.remove('d-none');
                }
            }

            const response = sendFeedback(csrfToken, uniqueId, chosenRating.toString(), null);

            response.then(resp => {
                if (resp.status !== 200) {
                    const feedbackError = document.querySelector('#feedbackError') as HTMLDivElement|null;
                    feedbackError?.classList.remove('d-none');
                }
            })
        });
    });

    userFeedbackForm.addEventListener('submit', (e) => {
        e.preventDefault();

        const response = sendFeedback(csrfToken, uniqueId, userRating.value, feedbackBody.value)

        response.then(resp => {
            const feedbackError = document.querySelector('#feedbackError') as HTMLDivElement|null;
            const feedbackSuccess = document.querySelector('#feedbackSuccess') as HTMLDivElement|null;
            if (feedbackError === null || feedbackSuccess === null) {
                return;
            }

            if (resp.status !== 200) {
                resp.json().then(resp => {
                    const feedbackErrors: Array<string> = resp.errors.feedback;
                    feedbackError.innerHTML = feedbackErrors.reduce((carry: string, err: string) => {
                            return carry + '<li>' + err + '</li>';
                        }, '<ul class="m-0">'
                    ) + '</ul>'
                });
                feedbackError.classList.remove('d-none');
            } else {
                userFeedbackForm.classList.add('d-none');
                feedbackSuccess.classList.remove('d-none');
                feedbackError.classList.add('d-none');
            }
        })
    });

    const sendFeedback = async (csrfToken: string, uniqueId: string, starRating: string, feedback: string | null) => {
        const fd = new FormData();
        fd.append('star_rating', starRating);
        fd.append('unique_id', uniqueId);

        if (feedback !== null) {
            fd.append('feedback', feedback);
        }

        return fetch('/feedback', {
            method: 'POST',
            credentials: 'same-origin',
            body: fd,
            headers: {
                Accept: 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            },
        }).then(resp => {
            return resp;
        });
    }

    const setRatingDescription = (chosenRating: number) => {
        const ratingDescription = document.getElementById('ratingDescription') as HTMLDivElement|null;

        if (ratingDescription === null) {
            return;
        }

        switch (chosenRating) {
            case 1: {
                ratingDescription.innerText = 'Very difficult'
                break;
            }
            case 2: {
                ratingDescription.innerText = 'Difficult'
                break;
            }
            case 3: {
                ratingDescription.innerText = 'Satisfactory'
                break;
            }
            case 4: {
                ratingDescription.innerText = 'Easy'
                break;
            }
            case 5: {
                ratingDescription.innerText = 'Very easy'
                break;
            }
            default: {
                ratingDescription.innerText = ''
                break;
            }
        }
    }

    const updateIcons = (chosenRating: number, icons: NodeListOf<HTMLElement>, grey: boolean = false) => {
        const newClass = grey ? 'ev-icon-star-grey' : 'ev-icon-star-yellow';

        for (let i = 0; i < 5; i++) {
            icons[i].classList.remove('ev-icon-star');
            icons[i].classList.remove('ev-icon-star-yellow');
            icons[i].classList.remove('ev-icon-star-grey');

            if (i + 1 <= chosenRating) {
                icons[i].classList.add(newClass);
            } else {
                icons[i].classList.add('ev-icon-star');
            }
        }
    }
}
